<template>
<div class="pageContainer">
  <router-link to="/new">New Stock</router-link> <br>
  <router-link to="/newnote">New Note</router-link> <br>
  <router-link to="/design">Design Guide</router-link>
  <p>update: 08/05/2018 09:35</p>
</div>
</template>

<script>
import firebase from 'firebase';
import * as Firebase from '../config.js';

export default {
  data(){ return{

  }},

  firebase: {
    stocks: Firebase.stocks
  },

  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// dashboard.vue?0ef54bde